import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

// appsetup - Get All (Read)
export const GetAllCustomer = createAsyncThunk(
  "/admin/customer-management/customer",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Customer_Management.customer}?name=${filter?.name || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteCustomer = createAsyncThunk(
  "masters/customer/delete",
  async (id, { rejectWithValue }) => {
    try {
      await DELETE(`${APIS.Customer_Management.customer}/${id}`);
      return id;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Get (Read)
export const GetAppSetUp = createAsyncThunk(
  "admin/customer-management/customer/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Customer_Management.customer}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Create (Add)
export const AddAppSetUp = createAsyncThunk(
  "admin/customer-management/customer/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Customer_Management.customer, data);
      return res; // The new AppSetUp object
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Delete
export const DeleteAppSetUp = createAsyncThunk(
  "admin/customer-management/customer/delete",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Customer_Management.customer}/${id}`);
      return id; // Return the id of the deleted AppSetUp
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const StatusCustomer = createAsyncThunk(
  "masters/customer/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Customer_Management.customer}/status/${id}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// AppSetUp - Status
export const StatusUpdateKyc = createAsyncThunk(
  "admin/customer/status",
  async ({ id, data, kyc_cancel_reason }, { rejectWithValue }) => {
    console.log(kyc_cancel_reason, "kyc_cancel_reason");

    try {
      const res = await POST(
        `${APIS.Customer_Management.customer}/kyc-status/${id}`,
        {
          status: data,
          kyc_cancel_reason: kyc_cancel_reason,
        }
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const StatusUpdateBank = createAsyncThunk(
  "admin/customer/status",
  async ({ id, data, bank_cancel_reason }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Customer_Management.customer}/bank-status/${id}`,
        {
          status: data,
          bank_cancel_reason: bank_cancel_reason,
        }
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const addFund = createAsyncThunk(
  "admin/customer/add-fund",
  async ({ id, amount }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Customer_Management.customer}/add-fund/${id}`,
        {
          amount: amount,
        }
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const withdrawFund = createAsyncThunk(
  "admin/customer/withdraw-fund",
  async ({ id, amount }, { rejectWithValue }) => {
    try {
      const res = await POST(
        `${APIS.Customer_Management.customer}/withdraw-fund/${id}`,
        {
          amount: amount,
          withdraw_type: "profit",
        }
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// get Customer KyC - Get (Read)
export const GetKyc = createAsyncThunk(
  "admin/customer/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Customer_Management.customer}/get-kyc/${id}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateKyc = createAsyncThunk(
  "admin/customer/update-kyc",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.Customer_Management.customer}/kyc/post/${id}`,
        data
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

// get Customer KyC - Get (Read)
export const GetBank = createAsyncThunk(
  "admin/customer/get-bank",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Customer_Management.customer}/get-bank/${id}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateBank = createAsyncThunk(
  "admin/customer/update-bank",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(
        `${APIS.Customer_Management.customer}/bank/post/${id}`,
        data
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetCustomerDetails = createAsyncThunk(
  "admin/customer/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Customer_Management.customer}/customer-details/${id}`
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const Slice = createSlice({
  name: "fund-request",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetAppSetUp, AddAppSetUp, UpdateAppSetUp, DeleteAppSetUp
      .addCase(GetAllCustomer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAllCustomer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAllCustomer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteCustomer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteCustomer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = state.data.filter((city) => city.id !== action.payload);
      })
      .addCase(DeleteCustomer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(AddAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(AddAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(AddAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(DeleteAppSetUp.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(DeleteAppSetUp.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (appsetup) => appsetup.id !== action.payload.id
        ); // Remove the AppSetUp with the deleted id
      })
      .addCase(DeleteAppSetUp.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })
      //
      .addCase(StatusUpdateKyc.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusUpdateKyc.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
          (appsetup) => appsetup.id !== action.payload.id
        ); // Remove the appsetup with the deleted id
      })
      .addCase(StatusUpdateKyc.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });

    // //
    // .addCase(StatusUpdateBank.pending, (state) => {
    //   state.status = IDS.SLICESTATUS.Loading;
    // })
    // .addCase(StatusUpdateBank.fulfilled, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Succeeded;
    //   // state.data = action.payload;
    //   state.data = state.data.filter(
    //     (appsetup) => appsetup.id !== action.payload.id
    //   ); // Remove the appsetup with the deleted id
    // })
    // .addCase(StatusUpdateBank.rejected, (state, action) => {
    //   state.status = IDS.SLICESTATUS.Failed;
    //   state.error = action.payload;
    // });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
